import {
    Inquiry,
    InquiryFetchArgs,
    getInquiryViews,
  } from '../../assets/ts/data/inquiry/inquiry'
  import useServerData from '../use-server-data'
  
  function useInquiryViews(fetchArgs: InquiryFetchArgs ) {
    const waitOnParentDependency = fetchArgs.waitOnParentDependency ?? false
    const {
      data: inquiries,
      error: inquiriesError,
      fetchData: fetchInquiries,
      isLoading: inquiriesAreLoading,
    } = useServerData<Inquiry, InquiryFetchArgs>(getInquiryViews, fetchArgs ,waitOnParentDependency)
    return {
      fetchInquiries,
      inquiries,
      inquiriesAreLoading,
      inquiriesError,
    }
  }
  
  export default useInquiryViews
  